import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { RemoteCreateFulfilmentAgent } from "../../../data/usecases/remote-create-fulfiment-agent";
import Endpoints from "../../../domain/endpoints";
import { CreateFulfilmentAgent } from "../../../domain/useages/create-fulfilment-agent";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface CreateFulfilmentAgentInterface {
  createFulfilmentAgent: Function;
}

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useCreateFulfilmentAgentSlice: StateCreator<
  CreateFulfilmentAgentInterface
> = (set, get) => ({
  createFulfilmentAgent: async (payload: CreateFulfilmentAgent) => {
     const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
     const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteCreateFulfilmentAgent = new RemoteCreateFulfilmentAgent(
      `${BASE_URL}${Endpoints.CREATE_FULFILMENT_AGENT}`,
      axiosHttpClient
    );
    let result = await remoteCreateFulfilmentAgent.create(payload);
  },
});
